import { MessageType, type ToolBeltSlot } from "odyssey-shared";

/**
 * The server's `toolBelt` (ADR-142 decision 3b, PROTOCOL.md 6.90.0) as the page's belt takes it. The text schema has
 * already checked every field when a message reaches here, so nothing is checked twice.
 */

/**
 * A `toolBelt`: the set it answers, 0 for a join's, the four slots and the selection.
 */
export interface ToolBeltEvent {
  readonly seq: number;
  readonly slots: readonly ToolBeltSlot[];
  readonly selected: number;
}

/**
 * A `toolBelt` as the page's belt takes it, or null for any other message.
 *
 * @param message A parsed server message.
 * @returns The event, or null.
 * @example
 * readToolBelt({ type: MessageType.ToolBelt, seq: 0, slots: [null, null, null, null], selected: 0 });
 * // { seq: 0, slots: [null, null, null, null], selected: 0 }
 */
export function readToolBelt(message: Readonly<Record<string, unknown>> & { readonly type: number }): ToolBeltEvent | null {
  if (message.type !== MessageType.ToolBelt) {
    return null;
  }
  return { seq: message["seq"] as number, slots: message["slots"] as readonly ToolBeltSlot[], selected: message["selected"] as number };
}
